import { createSlice } from "@reduxjs/toolkit";

import { setProp } from "Store/Actions";
import { setPropT } from "Store/Actions/ts";
import setObj from "lodash/set";
import { preCiqInformation } from "Pages/pre-ciq-network/Constants/preCiqInformation";
import { access } from "fs";
import { custom } from "zod";
const initialData = {
    assetsList: [],
    tabSelected: "files",
    asideBlockHeight: 0,
    isPartnerLoading: false,
    isCustomerLoading: false,
    isNetworkLoading: false,
    isOfferLoading: false,
    partnerList:[],
    customerList: [],
    networkList: [],
    offerList: [],
    filters: {selection: {sell_to_party: "", end_customer: "", network_id: [], offer_id: "", name: ""}},
    accountDropdown: [],
    assetsDownloadHistoryDialog: false,
    assetsFloderList: [],
    assetsListLoading: false,
    selectedFolder: "",
    assetsListTotalCount: 0,
    nextCursor: [{ offset: 0, nextCursor: "" }],
    selectedAsset: {},
    assetsDownloadHistory: [],
    assetsDownloadHistoryLoading: false,
    filteredBy: ""

}
const assetsSlice = createSlice({
    name: 'assets',
    initialState: initialData,
    reducers:{
        setAssetsList(state, action){
            state.assetsList = action.payload;
        },
    // List actions
     // Filter actions
    setFilterSelection: (state, action) => {
      state.filters.selection = {
        ...state.filters.selection,
        ...action.payload,
      };
    },

      setPartnerList(state, action) {
          state.partnerList = action.payload
        },
        setCustomerList(state, action) {
          state.customerList = action.payload;;
        },
        setNetworkList: (state, action) => {
      state.networkList = action.payload;
    },
        setAccountDropdown: (state, action) => {
  state.accountDropdown = action.payload;
},
  // Loader actions
    setLoader: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    },
      extraReducers(builder) {
            builder.addCase(setProp, (state, action: setPropT) => {
                if (action.payload.slice === assetsSlice.name) {
                    setObj(state, action.payload.key, action.payload.value);
                }
            })
        }
  
})
export default assetsSlice.reducer;
export const {setAssetsList,setFilterSelection,setPartnerList,setCustomerList,setNetworkList,setAccountDropdown,setLoader} = assetsSlice.actions;